// Import firebase
import { firebaseAuth, invoicesModel, rentsModel, propertiesModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
import { GenerateUID } from '@/mixins/helpers/GenerateUID'
import { InvoiceEventsRepository } from '@/repositories/invoice-events/InvoiceEventsRepository'

export const UpdateLateInvoice = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        GenerateUID,
        InvoiceEventsRepository

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        error: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        updateLateInvoiceHandler: function() {
 
            /*
            **  Add the line item
            **  @method: @here
            */

			this.addLineItem()
            .then(() => {

                /*
                **  Update ACH Fees
                **  @method: @here
                */

                if (!this.error) this.setACHFeesLateStatus();

            })
            .then(() => {

                /*
                **  Update Card Fees
                **  @method: @here
                */

                if (!this.error) this.setCardFeesLateStatus();

            })
            .then(() => {

                /*
                **  Update the Totals
                **  @method: @here
                */

                if (!this.error) this.setTotalsLateStatus();

            })
            .then(() => {

                /*
                **  Update the invoice to late
                **  @method: @here
                */
    
                if (!this.error) this.updateInvoiceLateStatus();

            })
            .then(() => {

                /* 
                ** Add late fees to rent metrics
                ** @method: @here
                */

                if (!this.error) this.updateRentMetricsLateFees();

            })
            .then(() => {

                /* 
                ** Set the new invoice event
                ** @method: @here
                */

                if (!this.error) this.setUpInvoiceEventLateStatus();

            })
            .then(() => {

                /* 
                ** Create the invoice event
                ** @method: @here
                */

                if (!this.error) this.createUpdateInvoiceEventLateStatus();

            })
            .then(() => {

                /* 
                ** Finish the update
                ** @method: @here
                */

                if (!this.error) this.finishUpdateLateStatus();

            })
            .then(() => {

                /* 
                ** If error, handle it
                ** @method: @here
                */

                if (this.error) this.handleError();

            });

        },

        sendToBugsnag: function(error, title) {

            /*
            **  Send to Bugsnag
            **  @service: Bugsnag/BugsnagService
            */
            
            this.reportAuthBugsnagError({
                title: title,
                errorType: 'Application',
                section: 'Events/Invoices',
                uid: 'AoTO1FbkysBGnHFwo7wj',
                error: error
            });

        },

        handleError: function() {

            try {

                /* 
                ** Close the modal
                ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
                */

                this.closeTheModal();

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display error message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Uh Oh!', 'We ran into a problem trying to update the invoice.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Handle the Error When Updating the Invoice Status to Late.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'i3uZboodAoDywF9Wqc44',
                    error: e
                });

            }

        },

        addLineItem: async function () {

            /*
            **  Add the line item
            **  @prop: invoice
            */

            try {

                this.invoice.attributes.line_items.push({
                    amount: this.invoice.attributes.charge.policy_late_fee,
                    type: 'late_fee',
                    description: moment(this.invoice.attributes.due_on.date * 1000).format('MMMM YYYY') + ' Late Fee',
                    paid: false,
                    paid_amount: 0
                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @method: @here
                */

                this.sendToBugsnag(e, 'Add invoice line item when updating invoice to late status.');

            }

        },

        setACHFeesLateStatus: function() {

            try {

                /*
                **  Set the total amount
                */

                let total = this.invoice.attributes.charge.total;
    
                /*
                **  Add late fee to total
                */

                total = total + this.invoice.attributes.charge.policy_late_fee;
    
                /*
                **  Calculate the Stripe variables
                */

                let stripeACHPercent =  Number(process.env.VUE_APP_STRIPE_ACH_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
                    stripeACHCents = Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
    
                /*
                **  Calculate platform fees
                */

                let platformFee = total * Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT);
                platformFee = Math.ceil(platformFee);
    
                /*
                **  Calculate stripe fees
                */

                let stripeFee = (total * stripeACHPercent) + stripeACHCents;
                stripeFee = Math.ceil(stripeFee);

                /*
                **  Calculate the total fees in pennies
                */
                
                let totalFees = platformFee + stripeFee;

                /*
                **  Calculate connect account amount
                */
                
                let connectAccountAmount = total - totalFees;
    
                /*
                **  Set the fees
                */
                
                this.invoice.attributes.charge.ach_fees.stripe.amount = Number(stripeFee);
                this.invoice.attributes.charge.ach_fees.platform.amount = Number(platformFee);
                this.invoice.attributes.charge.ach_fees.total_fees = Number(totalFees);
                this.invoice.attributes.charge.ach_fees.connect_account_amount = connectAccountAmount;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @method: @here
                */

                this.sendToBugsnag(e, 'Setting ACH Fees when updating invoice to late status.');

            }

		},

		setCardFeesLateStatus: function() {

            try {

                /*
                **  Set the total amount
                */

                let total = this.invoice.attributes.charge.total;

                /*
                **  Add late fee to total
                */

                total = total + this.invoice.attributes.charge.policy_late_fee;
    
                /*
                **  Calculate the Stripe variables
                */

                let stripeCardPercent = Number(process.env.VUE_APP_STRIPE_CARD_FEE_PERCENT) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_PERCENT),
                    stripeCardCents = Number(process.env.VUE_APP_STRIPE_CARD_FEE_CENTS) + Number(process.env.VUE_APP_STRIPE_EXPRESS_ACCOUNT_FEE_CENTS);
    
                /*
                **  Calculate platform fees
                */
                
                let platformFee = total * Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT);
                platformFee = Math.ceil(platformFee);

                /*
                **  Calculate stripe fees
                */

                let stripeFee = (total * stripeCardPercent) + stripeCardCents;
                stripeFee = Math.ceil(stripeFee);
    
                /*
                **  Calculate the total fees in pennies
                */

                let totalFees = platformFee + stripeFee;

                /*
                **  Calculate connect account amount
                */

                let connectAccountAmount = total - totalFees;

                /*
                **  Set the props
                */

                this.invoice.attributes.charge.card_fees.stripe.amount = Number(stripeFee);
                this.invoice.attributes.charge.card_fees.platform.amount = Number(platformFee);
                this.invoice.attributes.charge.card_fees.total_fees = Number(totalFees);
                this.invoice.attributes.charge.card_fees.connect_account_amount = connectAccountAmount;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @method: @here
                */

                this.sendToBugsnag(e, 'Setting Card Fees when updating invoice to late status.');

            }

		},

        setTotalsLateStatus: function() {

            try {

                /*
                **  Update Total
                */

                this.invoice.attributes.charge.total = this.invoice.attributes.charge.total + this.invoice.attributes.charge.policy_late_fee;

                /*
                **  Update Subtotal
                */

                this.invoice.attributes.charge.subtotal = this.invoice.attributes.charge.total;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @method: @here
                */

                this.sendToBugsnag(e, 'Setting the invoice totals when updating invoice to late status.');

            }

        },

        updateInvoiceLateStatus: function() {

            try {

                /*
                **  Update the doc
                **  @service: Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).update({
                    'attributes.description': this.invoice.attributes.description,
                    'attributes.status': this.invoice.attributes.status,
                    'attributes.line_items': this.invoice.attributes.line_items,
                    'attributes.charge': this.invoice.attributes.charge,
                    'meta.updated_at': moment().unix()
                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Update Invoice to Late in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'BEvnkeyd2dNPuZZMppah',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating an Invoice to Late.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'a22pB1nbcL3LmR6TRF4Z',
                    error: e
                });

            }

        },

        updateRentMetricsLateFees: function() {

            try {

                /*
                **  Calculate metrics
                */

                let totalLate = this.rent.metrics.total_late + 1;

                /*
                **  Update the doc
                **  @service: Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease_id).collection('rents').doc(this.rent_id).update({
                    
                    'metrics.total_late': totalLate,
                    'attributes.status': 'late',
                    'meta.updated_at': moment().unix()

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Update Total Late Metrics in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'z0WnIWmJYsTS66VOLIwI',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating the Total Late Metrics.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'm6U2EO8oAqDCoQhqB2iB',
                    error: e
                });

            }

        },

        setUpInvoiceEventLateStatus: function() {
        
            /*
            **  Set the invoice event data
            **  @location: Repositories/InvoiceEvents
            */

            try {

                this.new_invoice_event.id = this.generateUID();
                this.new_invoice_event.type = 'invoice.update';
                this.new_invoice_event.attributes.title = 'The invoice was updated on ' + moment().format() + '.';
                this.new_invoice_event.attributes.application = 'Nestd | Web';
                this.new_invoice_event.attributes.source = 'Nestd - ' + firebaseAuth.currentUser.displayName;
                this.new_invoice_event.attributes.request = {
                    status: this.invoice.attributes.status,
                    description: this.invoice.attributes.description
                };
                this.new_invoice_event.attributes.response = this.invoice;
                this.new_invoice_event.relationships.company = this.invoice.relationships.company;
                this.new_invoice_event.relationships.resident = this.invoice.relationships.resident;
                this.new_invoice_event.relationships.invoice = this.invoice.id;
                this.new_invoice_event.relationships.unit = this.invoice.relationships.unit;
                this.new_invoice_event.relationships.property = this.invoice.relationships.property;
                this.new_invoice_event.relationships.lease = this.invoice.relationships.lease;
                this.new_invoice_event.relationships.rent = this.invoice.relationships.rent;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @method: @here
                */

                this.sendToBugsnag(e, 'Setting the invoice event data when updating invoice to late status.');

            }

        },

        createUpdateInvoiceEventLateStatus: function() {

            try {

                /* 
                ** Create an invoice event
                ** @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.invoice.relationships.property).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).collection('events').doc(this.new_invoice_event.id).set(this.new_invoice_event)
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Create New Invoice Event in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'TslQNfZ42OrxnNuk49mz',
                        error: error
                    });

                });

                /* 
                ** Create a resident event
                ** @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.invoice.relationships.property).collection('residents').doc(this.invoice.relationships.resident).collection('events').doc(this.new_invoice_event.id).set(this.new_invoice_event)
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Create New Resident Event in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'rGiHytlhXmQnJMBMxOnA',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

				this.reportAuthBugsnagError({
					title: 'Unable to Query Firestore When Creating New Invoice Event.',
					errorType: 'Firestore Database',
					section: 'Events/Invoices',
                    uid: 't930ToqQ0tzJvd1u3b7W',
					error: e
				});

            }

        },

        finishUpdateLateStatus: function() {

            try {

                /* 
                ** Emit the refresh invoice event
                ** @service: @Vue
                */

                this.$emit('refreshInvoice', this.invoice);

                /* 
                ** Close the modal
                ** @location: Components/Property/Lease/Invoices/EditInvoiceModal
                */

                this.closeTheModal();

                /* 
                ** Hide the spinner
                ** @location: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                ** Display success message
                ** @service: @Window/SweetAlert
                */

                this.$swal('Success!', 'Your rent invoice has been updated.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Finish Up the Open Invoice Update.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'RLC79zzxHUWiEoDVfdHM',
                    error: e
                });

            }

        }

    }

}